import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../service/report.service';

@Component({
  selector: 'app-sig-result',
  templateUrl: './sig-result.component.html',
  styleUrls: ['./sig-result.component.scss']
})
export class SigResultComponent implements OnInit {
  // public sidecutIndexContainer:any = [0];
  // public sidecut:string;
  // public sidekey:string;
  // public index:number;
  // public bordersidecut:string;
  // public bordersidekey:string;
  // public borderindex:number;
  // public sidecutIndex:number = 0;
  // public sideKeyIndex:number = 0;
  public iterateIndex:number = 0;



  constructor(
    public reportService:ReportService,
  ) { }

  ngOnInit(): void {
    // console.log(this.reportService.sigResultArr);
    // this.bordersidecut = this.reportService.sigResultArr[this.sidecutIndex]['sidecut'];
    // this.bordersidekey = Object.keys(this.reportService.sigResultArr[this.sidecutIndex]['result'])[this.sideKeyIndex];
    // this.borderindex = 0;
    // console.log(this.sidecut,this.sidekey,this.index);
  }
  ngOnDestroy()
  {
    // this.sidecut = null;
    // this.sidekey = null;
    // this.index = null;
    // this.bordersidekey = null;
    // this.bordersidecut = null;
    // this.borderindex = null;
  }
  CheckTabClose(ind:Number){
    let ind1 = this.reportService.sigresultsidecutIndexContainer.findIndex(va => va === ind);
    if(ind1 === -1)
    {
      return 1;
    }
    return 0;
  }
  OpenSideTabResult(ind){
    this.reportService.sigresultsidecutIndexContainer.push(ind);
  
  }
  CloseSideTabResult(event,ind){
    let ind1 = this.reportService.sigresultsidecutIndexContainer.findIndex(va => va === ind);
    this.reportService.sigresultsidecutIndexContainer.splice(ind1,1);
  }
  ResultContSidecutCheck(ind){
    let ind1 = this.reportService.sigresultsidecutIndexContainer.findIndex(va => va === ind);
    return ind1 === -1 ? 0 : 1;
  }
  // HoverOnResultLink(sidecut,sidekey,index)
  // {
  //   this.sidecut = sidecut;
  //   this.sidekey = sidekey;
  //   this.index = index;
  // }
  // CheckHoverLink(sidecut,sidekey,index){
  //   if(sidecut === this.sidecut && sidekey === this.sidekey && index === this.index)
  //   {
  //     return 1;
  //   }
  //   return 0;
  // }
  checkBorderResultLink(sidecut,sidekey,index){
    if(sidecut === this.reportService.sigresultbordersidecut && sidekey === this.reportService.sigresultbordersidekey && index === this.reportService.sigresultborderIndex)
    {
      return 1;
    }
    return 0;
  }
  // Next()
  // {
  //   // if(this.sidecutIndex < this.reportService.sigResultArr.length)
  //   // {
  //   //   let sidekeyvaluearr:any,sidecutresultarr:any;
  //   //   sidekeyvaluearr = Object.values(this.reportService.sigResultArr[this.sidecutIndex]['result'])[this.sideKeyIndex];
  //   //   sidecutresultarr = Object.keys(this.reportService.sigResultArr[this.sidecutIndex]['result']).length;
  //   //   if(this.iterateIndex+1 === sidekeyvaluearr.length)
  //   //   {
  //   //     this.iterateIndex = 0;
  //   //     this.sideKeyIndex += 1;
  //   //     this.bordersidekey = Object.keys(this.reportService.sigResultArr[this.sidecutIndex]['result'])[this.sideKeyIndex];
  //   //     this.borderindex = 0;
  //   //     if(this.sideKeyIndex === sidecutresultarr)
  //   //     {
  //   //       this.iterateIndex = 0;
  //   //       this.sidecutIndex += 1;
  //   //       this.sideKeyIndex = 0;
  //   //       this.sidecutIndexContainer = [];
  //   //       this.sidecutIndexContainer.push(this.sidecutIndex);
  //   //       this.bordersidecut = this.reportService.sigResultArr[this.sidecutIndex]['sidecut'];
  //   //       this.bordersidekey = Object.keys(this.reportService.sigResultArr[this.sidecutIndex]['result'])[this.sideKeyIndex];
  //   //       this.borderindex = 0;
  //   //     }
  //   //   }
  //   //   else
  //   //   {
  //   //     this.iterateIndex += 1;
  //   //     this.borderindex = this.iterateIndex;
  //   //   }
  //   // }
  //   // else
  //   // {
  //   //   this.sidecutIndex = 0;
  //   //   this.sideKeyIndex = 0;
  //   //   this.iterateIndex = 0;
  //   //   this.bordersidecut = this.reportService.sigResultArr[this.sidecutIndex]['sidecut'];
  //   //   this.bordersidekey = Object.keys(this.reportService.sigResultArr[this.sidecutIndex]['result'])[this.sideKeyIndex];
  //   //   this.borderindex = 0;
  //   //   this.sidecutIndexContainer = [0];
  //   // }
  // }
  // Prev(){
  //   // console.log(this.iterateIndex,'115');
  //   // if(this.iterateIndex > 0)
  //   // {
  //   //   this.borderindex = this.iterateIndex < 0 ? 0 : this.iterateIndex;
  //   // }
  //   // else if(this.iterateIndex < 0)
  //   // {
  //   //   let v1:any;
  //   //   v1 = Object.values(this.reportService.sigResultArr[this.sidecutIndex]['result'])[this.sideKeyIndex];
  //   //   this.iterateIndex = v1.length+1;
  //   //   if(this.sideKeyIndex > 0)
  //   //   {
  //   //     this.sideKeyIndex -= 1;
  //   //   }
  //   //   this.bordersidekey = Object.keys(this.reportService.sigResultArr[this.sidecutIndex]['result'])[this.sideKeyIndex];
  //   //   this.borderindex = this.iterateIndex;
  //   // }
  //   // this.iterateIndex -= 1;
  // }
  // // BorderResultLink(sidecutindex,sidekeyindex,index)
  // // {
  // //   this.reportService.sigresultsidecutIndex = sidecutindex;
  // //   this.reportService.sigresultsidekeyIndex = sidekeyindex;
  // //   this.reportService.sigresultbordersidecut = this.reportService.sigResultArr[this.sidecutIndex]['sidecut'];
  // //   this.reportService.sigresultbordersidekey = Object.keys(this.reportService.sigResultArr[this.sidecutIndex]['result'])[this.sideKeyIndex];
  // //   this.reportService.sigresultborderIndex = index;
  // //   this.iterateIndex = this.reportService.sigresultborderIndex;
  // //   // console.log(this.bordersidecut,this.bordersidekey,this.borderindex);
  // // }

}
